export const getTranslations = t => {
  return {
    familyResults: t("kf.viewFamilyResults"),
    viewSterlingResults: t("kf.viewSterlingResults"),
    items: t("kf.plp.items"),
    bundle: t("kf.plp.bundle"),
    refPrice: t("kf.pdp.label.refPrice"),
    percentOff: t("kf.pdp.label.percentOff"),
    inclusiveOfAllTaxes: t("kf.pdp.label.inclusiveOfAllTaxes"),
    shopNow: t("kf.plp.label.shopNow"),
  }
}
